export const PANIC_ERROR = new Error('Panic should never occur in the system');
